import { Link } from "react-router-dom";
import { categories } from "@/mocks/guawa";

export default function Categories() {
  return (
    <section id="site-topics" className="bg-cream-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">主题分类</span>
            <h2 className="mt-1 text-2xl font-extrabold tracking-tight text-ink-900 md:text-3xl">想吃哪块瓜，直接进</h2>
            <p className="mt-2 text-sm text-ink-500">按兴趣直达对应热议栏目，围观更省心。</p>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-white px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50 whitespace-nowrap"
          >
            进入热议专区 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <Link
              key={c.id}
              to="/topics"
              className="group flex items-start gap-4 rounded-2xl border border-cream-200 bg-white p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-xl text-white transition-colors ${
                  c.hot ? "bg-primary-500" : "bg-ink-500"
                }`}
              >
                <i className={c.icon}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-bold text-ink-900">{c.name}</h3>
                  {c.hot && (
                    <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-700">热</span>
                  )}
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-500">{c.desc}</p>
                <p className="mt-2.5 text-xs font-medium text-primary-600">
                  {c.count} 个热议话题
                  <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5"></i>
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}